import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const chatApi = api
  .enhanceEndpoints({ addTagTypes: ['Chat'] })
  .injectEndpoints({
    endpoints: builder => ({
      insertChats: builder.mutation<any, any>({
        query: message => ({
          url: `chatbot/`,
          method: 'POST',
          body: message
        }),
        invalidatesTags: ['Chat']
      }),
      insertChatsUser: builder.mutation<any, any>({
        query: message => ({
          url: `chatbot/user/`,
          method: 'POST',
          body: message
        }),
        invalidatesTags: ['Chat']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useInsertChatsMutation, useInsertChatsUserMutation } = chatApi;

